export enum PublicRoutes {
  CreateWorkspace = '/create-workspace',
  CreateNewPassword = '/create-new-password',
  Login = '/login',
  ResetPassword = '/reset-password',
  SessionExpired = '/session-expired',
  SignUp = '/sign-up',
}

export enum SetupWorkspaceRoutes {
  CheckInbox = 'check-inbox',
  Password = 'password',
}

export enum AuthorizedRoutes {
  Settings = 'settings',
  SetupConnection = 'connections/:name/setup',
}

export enum SettingsRoutes {
  User = 'user',
}

export enum ConnectionSetupRoutes {
  ConnectionVerified = 'verified',
  SelectWorkspaces = 'select-workspaces',
  Settings = 'settings',
  SignIn = 'sign-in',
}
